export const shipmentTypes = {
    FETCH_REQUEST: "SHIPMENT_FETCH_REQUEST",
    FETCH_SUCCESS: "SHIPMENT_FETCH_SUCCESS",
    FETCH_FAILURE: "SHIPMENT_FETCH_FAILURE",
    UPDATE_REQUEST: "SHIPMENT_UPDATE_REQUEST",
    UPDATE_UI: "SHIPMENT_UPDATE_UI",
    UPDATE_FILTER: "SHIPMENT_UPDATE_FILTER",
    CLEAR_FILTER: "SHIPMENT_CLEAR_FILTER",
    UPDATE_BULK_SELECT: "SHIPMENT_UPDATE_BULK_SELECT",
    FETCH_DEVICE_DETAILS: "FETCH_DEVICE_DETAILS",
    UPDATE_PAGINATION_REQUEST: "SHIPMENT_UPDATE_PAGINATION_REQUEST",
    DOWNLOAD_REQUEST: "SHIPMENT_DOWNLOAD_REQUEST",
    DOWNLOAD_SUCCESS: "SHIPMENT_DOWNLOAD_SUCCESS",
    DOWNLOAD_FAILURE: "SHIPMENT_DOWNLOAD_FAILURE",
    CREATE_REQUEST: "SHIPMENT_CREATE_REQUEST",
    CREATE_SUCCESS: "SHIPMENT_CREATE_SUCCESS",
    CREATE_FAILURE: "SHIPMENT_CREATE_FAILURE",
    FETCH_DEVICE_REQUEST: "SHIPMENT_DEVICEFETCH_REQUEST",
    FETCH_DEVICE_SUCCESS: "SHIPMENT_DEVICEFETCH_SUCCESS",
    FETCH_DEVICE_FAILURE: "SHIPMENT_DEVICEFETCH_FAILURE",
    FETCH_PROFILE_REQUEST: "SHIPMENT_PROFILE_FETCH_REQUEST",
    FETCH_PROFILE_SUCCESS: "SHIPMENT_PROFILE_FETCH_SUCCESS",
    FETCH_PROFILE_FAILURE: "SHIPMENT_PROFILE_FETCH_FAILURE",
    SINGLE_DELETE_REQUEST: "SHIPMENT_SINGLE_DELETE_REQUEST",
    SINGLE_DELETE_SUCCESS: "SHIPMENT_SINGLE_DELETE_SUCCESS",
    SINGLE_DELETE_FAILURE: "SHIPMENT_SINGLE_DELETE_FAILURE",
    BULK_DELETE_REQUEST: "SHIPMENT_BULK_DELETE_REQUEST",
    BULK_DELETE_SUCCESS: "SHIPMENT_BULK_DELETE_SUCCESS",
    BULK_DELETE_FAILURE: "SHIPMENT_BULK_DELETE_FAILURE",
    SINGLE_CANCEL_REQUEST: "SHIPMENT_SINGLE_CANCEL_REQUEST",
    SINGLE_CANCEL_SUCCESS: "SHIPMENT_SINGLE_CANCEL_SUCCESS",
    SINGLE_CANCEL_FAILURE: "SHIPMENT_SINGLE_CANCEL_FAILURE",
    BULK_CANCEL_REQUEST: "SHIPMENT_BULK_CANCEL_REQUEST",
    BULK_CANCEL_SUCCESS: "SHIPMENT_BULK_CANCEL_SUCCESS",
    BULK_CANCEL_FAILURE: "SHIPMENT_BULK_CANCEL_FAILURE",
    FETCH_ALERT_REQUEST: "SHIPMENT_ALERT_REQUEST",
    FETCH_ALERT_SUCCESS: "SHIPMENT_ALERT_SUCCESS",
    FETCH_ALERT_FAILURE: "SHIPMENT_ALERT_FAILURE",
    UPDATE_SHIP_REQUEST: "SHIPMENT_UPDATE_SHIP_REQUEST",
    UPDATE_SHIP_SUCCESS: "SHIPMENT_UPDATE_SHIP_SUCCESS",
    UPDATE_SHIP_FAILURE: "SHIPMENT_UPDATE_SHIP_FAILURE",
    SINGLE_UPDATE_STATE_REQUEST: "SHIPMENT_SINGLE_UPDATE_STATE_REQUEST",
    SINGLE_UPDATE_STATE_SUCCESS: "SHIPMENT_SINGLE_UPDATE_STATE_SUCCESS",
    SINGLE_UPDATE_STATE_FAILURE: "SHIPMENT_SINGLE_UPDATE_STATE_FAILURE",
    BULK_EDIT_REQUEST: "SHIPMENT_BULK_EDIT_REQUEST",
    BULK_EDIT_SUCCESS: "SHIPMENT_BULK_EDIT_SUCCESS",
    BULK_EDIT_FAILURE: "SHIPMENT_BULK_EDIT_FAILURE",
    FETCH_DEVICE_NAME_REQUEST: "SHIPMENT_FETCH_DEVICE_NAME_REQUEST",
    FETCH_DEVICE_NAME_SUCCESS: "SHIPMENT_FETCH_DEVICE_NAME_SUCCESS",
    FETCH_DEVICE_NAME_FAILURE: "SHIPMENT_FETCH_DEVICE_NAME_FAILURE",
    FETCH_ALERTS_CONTENT_REQUEST: "FETCH_ALERTS_CONTENT_REQUEST",
    FETCH_ALERTS_CONTENT_SUCCESS: "FETCH_ALERTS_CONTENT_SUCCESS",
    FETCH_ALERTS_CONTENT_FAILURE: "FETCH_ALERTS_CONTENT_FAILURE",
    SET_ACTIVE_TAB_GLOBAL: "SET_ACTIVE_TAB_GLOBAL",
    SET_SHIPMENT_DATA: "SET_SHIPMENT_DATA",
    SET_SHIPMENT_STATUS: "SET_SHIPMENT_STATUS",
    SET_SHIPMENT_TITLES_FOR_FILTER: "SET_SHIPMENT_TITLES_FOR_FILTER",
    SET_SHIPMENT_TITLES_FOR_HIGHLIGHT: "SET_SHIPMENT_TITLES_FOR_HIGHLIGHT",
    UPDATE_MAP: "SHIPMENT_UPDATE_MAP",
    UPDATE_IS_LOADING: "SHIPMENT_UPDATE_IS_LOADING",
    BULK_UPDATE_STATE_REQUEST: "SHIPMENT_BULK_UPDATE_STATE_REQUEST",
    BULK_UPDATE_STATE_SUCCESS: "SHIPMENT_BULK_UPDATE_STATE_SUCCESS",
    BULK_UPDATE_STATE_FAILURE: "SHIPMENT_BULK_UPDATE_STATE_FAILURE",
    FETCH_LOCATION_ALERTS: "FETCH_LOCATION_ALERTS",
    FETCH_LOCATION_ALERTS_SUCCESS: "FETCH_LOCATION_ALERTS_SUCCESS",
    SET_SHIPMENT_TRACK:'SET_SHIPMENT_TRACK',
    LOGOUT: "SHIPMENT_LOGOUT",
    FETCH_ALL_REQUEST: "SHIPMENT_FETCH_ALL_REQUEST",
    FETCH_ALL_SUCCESS: "SHIPMENT_FETCH_ALL_SUCCESS",
    FETCH_ALL_FAILURE: "SHIPMENT_FETCH_ALL_FAILURE",
    SET_TRACK_DATA_LOADED: "SET_TRACK_DATA_LOADED"
  };
  
  export const fetchRequest = (req) => ({
    type: shipmentTypes.FETCH_REQUEST,
    payload: req,
  });

   export const setTrackDataLoaded = () => ({
    type: shipmentTypes.SET_TRACK_DATA_LOADED,
  });

  export const fetchLocationAlertsAction = (req) => ({
    type: shipmentTypes.FETCH_LOCATION_ALERTS,
    payload: req,
  });

  export const fetchLocationAlertsSuccess = (payload) => ({
    type: shipmentTypes.FETCH_LOCATION_ALERTS_SUCCESS,
    payload: payload,
  });

  // export const fetchRequest = (req) => ({
  //   type: shipmentTypes.FETCH_REQUEST,
  //   payload: req,
  // });

  export const fetchSuccess = (resp) => ({
    type: shipmentTypes.FETCH_SUCCESS,
    payload: resp,
  });
  
  export const fetchFailure = (resp) => ({
    type: shipmentTypes.FETCH_FAILURE,
    payload: resp,
  });
  
  export const updateRequest = (req) => ({
    type: shipmentTypes.UPDATE_REQUEST,
    payload: req,
  });
  
  export const updateUI = (req) => ({
    type: shipmentTypes.UPDATE_UI,
    payload: req,
  });
  
  export const updateFilter = (req) => ({
    type: shipmentTypes.UPDATE_FILTER,
    payload: req,
  });

  export const clearFilter = (req) => ({
    type: shipmentTypes.CLEAR_FILTER,
    payload: req,
  });
  
  export const updateBulkSelect = (req) => ({
    type: shipmentTypes.UPDATE_BULK_SELECT,
    payload: req,
  });
  
  export const deviceDetailsRequest = (req) => ({
    type: shipmentTypes.FETCH_DEVICE_DETAILS,
    payload: req,
  });
  
  export const updatePaginationRequest = (req) => ({
    type: shipmentTypes.UPDATE_PAGINATION_REQUEST,
    payload: req,
  });
  export const fetchDeviceRequest = () => ({
    type: shipmentTypes.FETCH_DEVICE_REQUEST,
  });
  
  export const fetchDeviceSuccess = (resp) => ({
    type: shipmentTypes.FETCH_DEVICE_SUCCESS,
    payload: resp,
  });
  
  export const fetchDeviceFailure = (resp) => ({
    type: shipmentTypes.FETCH_DEVICE_FAILURE,
    payload: resp,
  });
  export const fetchProfileRequest = (resp) => ({
    type: shipmentTypes.FETCH_PROFILE_REQUEST,
    payload: resp
  });
  
  export const fetchProfileSuccess = (resp) => ({
    type: shipmentTypes.FETCH_PROFILE_SUCCESS,
    payload: resp,
  });
  
  export const fetchProfileFailure = (resp) => ({
    type: shipmentTypes.FETCH_PROFILE_FAILURE,
    payload: resp,
  });
  export const fetchAlertRequest = () => ({
    type: shipmentTypes.FETCH_ALERT_REQUEST,
  });
  
  export const fetchAlertSuccess = (resp) => ({
    type: shipmentTypes.FETCH_ALERT_SUCCESS,
    payload: resp,
  });
  
  export const fetchAlertFailure = (resp) => ({
    type: shipmentTypes.FETCH_ALERT_FAILURE,
    payload: resp,
  });
  
  export const downloadRequest = () => ({
    type: shipmentTypes.DOWNLOAD_REQUEST,
  });
  
  export const downloadSuccess = (resp) => ({
    type: shipmentTypes.DOWNLOAD_SUCCESS,
    payload: resp,
  });
  
  export const downloadFailure = (error) => ({
    type: shipmentTypes.DOWNLOAD_FAILURE,
    payload: error,
  });
  export const createRequest = (req) => ({
    type: shipmentTypes.CREATE_REQUEST,
    payload: req,
  });
  
  export const createSuccess = (resp) => ({
    type: shipmentTypes.CREATE_SUCCESS,
    payload: resp,
  });
  
  export const createFailure = (error) => ({
    type: shipmentTypes.CREATE_FAILURE,
    payload: error,
  });
  export const updateshipRequest = (req) => ({
    type: shipmentTypes.UPDATE_SHIP_REQUEST,
    payload: req,
  });
  
  export const updateshipSuccess = (resp) => ({
    type: shipmentTypes.UPDATE_SHIP_SUCCESS,
    payload: resp,
  });
  
  export const updateshipFailure = (error) => ({
    type: shipmentTypes.UPDATE_SHIP_FAILURE,
    payload: error,
  });
  
  export const singleDeleteRequest = (req) => ({
    type: shipmentTypes.SINGLE_DELETE_REQUEST,
    payload: req,
  });
  
  export const singleDeleteRequestSuccess = (resp) => ({
    type: shipmentTypes.SINGLE_DELETE_SUCCESS,
    payload: resp,
  });
  
  export const singleDeleteRequestFailure = (resp) => ({
    type: shipmentTypes.SINGLE_DELETE_FAILURE,
    payload: resp,
  });
  
  
  export const bulkDeleteRequest = () => ({
    type: shipmentTypes.BULK_DELETE_REQUEST,
  });
  
  export const bulkDeleteRequestSuccess = (resp) => ({
    type: shipmentTypes.BULK_DELETE_SUCCESS,
    payload: resp,
  });
  
  export const bulkDeleteRequestFailure = (resp) => ({
    type: shipmentTypes.BULK_DELETE_FAILURE,
    payload: resp,
  });
  export const singleCancelRequest = (req) => ({
    type: shipmentTypes.SINGLE_CANCEL_REQUEST,
    payload: req,
  });
  
  export const singleCancelRequestSuccess = (resp) => ({
    type: shipmentTypes.SINGLE_CANCEL_SUCCESS,
    payload: resp,
  });
  
  export const singleCancelRequestFailure = (resp) => ({
    type: shipmentTypes.SINGLE_CANCEL_FAILURE,
    payload: resp,
  });
  
  
  export const bulkCancelRequest = () => ({
    type: shipmentTypes.BULK_CANCEL_REQUEST,
  });
  
  export const bulkCancelRequestSuccess = (resp) => ({
    type: shipmentTypes.BULK_CANCEL_SUCCESS,
    payload: resp,
  });
  
  export const bulkCancelRequestFailure = (resp) => ({
    type: shipmentTypes.BULK_CANCEL_FAILURE,
    payload: resp,
  });
  
  export const updateSingleStateRequest = () => ({
    type: shipmentTypes.SINGLE_UPDATE_STATE_REQUEST,
  });
  
  export const updateSingleStateSuccess = (resp) => ({
    type: shipmentTypes.SINGLE_UPDATE_STATE_SUCCESS,
    payload: resp,
  });
  
  export const updateSingleStateFailure = (error) => ({
    type: shipmentTypes.SINGLE_UPDATE_STATE_FAILURE,
    payload: error,
  });

  export const updateBulkStateRequest = () => ({
    type: shipmentTypes.BULK_UPDATE_STATE_REQUEST,
  });
  
  export const updateBulkStateSuccess = (resp) => ({
    type: shipmentTypes.BULK_UPDATE_STATE_SUCCESS,
    payload: resp,
  });
  
  export const updateBulkStateFailure = (error) => ({
    type: shipmentTypes.BULK_UPDATE_STATE_FAILURE,
    payload: error,
  });
  
  export const bulkEditRequest = () => ({
    type: shipmentTypes.BULK_EDIT_REQUEST,
  });
  
  export const bulkEditRequestSuccess = (resp) => ({
    type: shipmentTypes.BULK_EDIT_SUCCESS,
    payload: resp,
  });
  
  export const bulkEditRequestFailure = (resp) => ({
    type: shipmentTypes.BULK_EDIT_FAILURE,
    payload: resp,
  });
  export const fetchDeviceNameRequest = (req) => ({
    type: shipmentTypes.FETCH_DEVICE_NAME_REQUEST,
    payload: req,
  });
  
  export const fetchDeviceNameSuccess = (resp) => ({
    type: shipmentTypes.FETCH_DEVICE_NAME_SUCCESS,
    payload: resp,
  });
  
  export const fetchDeviceNameFailure = (resp) => ({
    type: shipmentTypes.FETCH_DEVICE_NAME_FAILURE,
    payload: resp,
  });
  
  export const fetchAlertsContentRequest = (payload) => ({
    type: shipmentTypes.FETCH_ALERTS_CONTENT_REQUEST,
    payload,
  });
  
  export const fetchAlertsContentSuccess = (resp) => ({
    type: shipmentTypes.FETCH_ALERTS_CONTENT_SUCCESS,
    payload: resp,
  });
  
  export const fetchAlertsContentFailure = (error) => ({
    type: shipmentTypes.FETCH_ALERTS_CONTENT_FAILURE,
    payload: error,
  });

  export const setActiveTabGlobal = (payload) => ({
    type: shipmentTypes.SET_ACTIVE_TAB_GLOBAL,
    payload,
  });

  export const setShipmentDataGlobal = (payload) => ({
    type: shipmentTypes.SET_SHIPMENT_DATA,
    payload,
  });

  export const setShipmentStatusGlobal = (payload) => ({
    type: shipmentTypes.SET_SHIPMENT_STATUS,
    payload,
  });

  export const setShipmentTitlesForFilter = (payload) => ({
    type: shipmentTypes.SET_SHIPMENT_TITLES_FOR_FILTER,
    payload,
  });

    export const setShipmentTitlesForHighlight = (payload) => ({
    type: shipmentTypes.SET_SHIPMENT_TITLES_FOR_HIGHLIGHT,
    payload,
  });

  export const updateMap = (req) => ({
    type: shipmentTypes.UPDATE_MAP,
    payload: req,
  });

  export const updateIsLoading = (val) =>{
    return ({
    type: shipmentTypes.UPDATE_IS_LOADING,
    payload: val,
  })};
  
  export const shipmentLogout = () =>{
    return ({
    type: shipmentTypes.LOGOUT,
  })};

  export const fetchAllRequest = (req) => ({
    type: shipmentTypes.FETCH_ALL_REQUEST,
    payload: req,
  });

  export const fetchALLSuccess = (resp) => ({
    type: shipmentTypes.FETCH_ALL_SUCCESS,
    payload: resp,
  });
  
  export const fetchAllFailure = (resp) => ({
    type: shipmentTypes.FETCH_ALL_FAILURE,
    payload: resp,
  });